var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AllEntityTypeConfigurationConstants } from "../models/basics/basics.models";
import * as Enumerable from "linq";
import { computedFrom } from "aurelia-framework";
import { ArrayUtils } from "../utilities/arrays";
import { Reflection } from "../utilities/reflection";
import { SignalFunctions } from "../services/basics/signal-client.service";
var BaseWidgetPlugin = /** @class */ (function () {
    function BaseWidgetPlugin() {
    }
    return BaseWidgetPlugin;
}());
export { BaseWidgetPlugin };
var BaseWidget = /** @class */ (function () {
    function BaseWidget(signalService) {
        this.signalService = signalService;
        this.signalService.subscribe(SignalFunctions.refreshData, this.refreshData);
    }
    BaseWidget.prototype.addGlobalWidgetPlugin = function (plugin) {
        BaseWidget.globalWidgetPlugins.push(plugin);
    };
    BaseWidget.prototype.removeGlobalWidgetPlugin = function (plugin) {
        var index = ArrayUtils.findIndex(BaseWidget.globalWidgetPlugins, function (x) { return x == plugin; });
        if (index > -1) {
            BaseWidget.globalWidgetPlugins.splice(index, 1);
        }
    };
    BaseWidget.prototype.activate = function (model) {
        this.model = model;
        this.onActivate(this.model);
        BaseWidget.globalWidgetPlugins.forEach(function (x) { return x.onActivate(); });
    };
    BaseWidget.prototype.deactivate = function () {
        BaseWidget.globalWidgetPlugins.forEach(function (x) { return x.onDeactivate(); });
    };
    BaseWidget.prototype.refreshData = function (x) {
        var model = this.model;
        if (model) {
            var item = Enumerable.from(AllEntityTypeConfigurationConstants)
                .firstOrDefault(function (y) { return y.uri && model.entityTypeUri.replace(/\s/g, "").toLowerCase() == y.uri.replace(/\s/g, "").toLowerCase(); });
            if (item && item.uri == x) {
                this.onActivate(this.model);
            }
        }
    };
    BaseWidget.globalWidgetPlugins = [];
    return BaseWidget;
}());
export { BaseWidget };
var BaseWidgetConfiguration = /** @class */ (function () {
    function BaseWidgetConfiguration(entityTypeConfigurationHelper) {
        this.entityTypeConfigurationHelper = entityTypeConfigurationHelper;
        this.entityTypes = this.entityTypeConfigurationHelper.getConfiguration(Enumerable.from(AllEntityTypeConfigurationConstants).select(function (x) { return x.uri; }).toArray());
        this.isNewQuery = false;
    }
    Object.defineProperty(BaseWidgetConfiguration.prototype, "entityTypeUri", {
        get: function () {
            return this._entityTypeUri;
        },
        set: function (value) {
            this._entityTypeUri = value;
            this.entityType = this.entityTypes.filter(function (x) { return x.uri == value; })[0];
            this.entityTypeChanged();
        },
        enumerable: false,
        configurable: true
    });
    BaseWidgetConfiguration.prototype.activate = function (model) {
        var _this = this;
        model.getModel = function () { return _this.getModel(_this); };
        if (model.widgetModel) {
            this.setModel(model.widgetModel());
        }
        else {
            this.isNewQuery = true;
            this.entityTypeUri = this.entityTypes[0].uri;
        }
        this.onActivated();
    };
    BaseWidgetConfiguration.prototype.equalityComparer = function (a, b) {
        if (a && b) {
            return JSON.stringify(a) === JSON.stringify(b);
        }
        return false;
    };
    BaseWidgetConfiguration.prototype.onActivated = function () {
    };
    __decorate([
        computedFrom(Reflection.getPropertyPath(function (x) { return x._entityTypeUri; })),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], BaseWidgetConfiguration.prototype, "entityTypeUri", null);
    return BaseWidgetConfiguration;
}());
export { BaseWidgetConfiguration };
var BaseQueryWidgetConfiguration = /** @class */ (function (_super) {
    __extends(BaseQueryWidgetConfiguration, _super);
    function BaseQueryWidgetConfiguration() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseQueryWidgetConfiguration.prototype, "queryEditor", {
        get: function () {
            return this._queryEditor;
        },
        set: function (value) {
            this._queryEditor = value;
            if (this.entityTypeUri) {
                this.activateQuery();
            }
        },
        enumerable: false,
        configurable: true
    });
    BaseQueryWidgetConfiguration.prototype.saveManageColumns = function () { };
    BaseQueryWidgetConfiguration.prototype.entityTypeChanged = function () {
        if (this.model &&
            this.entityTypeUri &&
            this.model.entityTypeUri &&
            this.model.entityTypeUri.replace(/\s/g, "").toLowerCase() != this.entityTypeUri.replace(/\s/g, "").toLowerCase()) {
            this.model = null;
        }
        this.activateQuery();
    };
    BaseQueryWidgetConfiguration.prototype.setModel = function (model) {
        this.model = model;
        this.title = model.title;
        if (model.entityTypeUri) {
            this.activateQuery();
        }
        this.setModelOverride(model);
    };
    BaseQueryWidgetConfiguration.prototype.setModelOverride = function (model) { };
    BaseQueryWidgetConfiguration.prototype.activateQuery = function () {
        if (this.queryEditor && this.entityTypeUri) {
            var self_1 = this;
            this.queryEditor.activateInternal(this.entityTypeUri.replace(/\s/g, ""), function () {
                self_1.runAfterInitialize();
            });
        }
        else if (this.model && this.model.entityTypeUri && !this.entityTypeUri) {
            this.entityTypeUri = this.model.entityTypeUri;
        }
    };
    BaseQueryWidgetConfiguration.prototype.runAfterInitialize = function () {
        var _this = this;
        if (!this.model) {
            return;
        }
        this.queryEditor.queryId = this.model.selectedSavedQueryId;
        setTimeout(function () {
            _this.queryEditor.selectedFilters = _this.model.queryFilters;
            if (_this.model.columns && _this.model.columns.length > 0)
                _this.queryEditor.columns = _this.model.columns;
        });
    };
    return BaseQueryWidgetConfiguration;
}(BaseWidgetConfiguration));
export { BaseQueryWidgetConfiguration };
